import type { QuickFilterTotals } from "../../../components/Organismos/Table/FilteredTable.types";

type ProfessionalsFilterStatsProps = {
  totals: QuickFilterTotals;
  className?: string;
};

function StatLine({ label, value }: { label: string; value: number }) {
  return (
    <p className="text-sm text-gray-font">
      {label}: <span className="font-bold">{value}</span>
    </p>
  );
}

export default function ProfessionalsFilterStats({
  totals,
  className = "",
}: ProfessionalsFilterStatsProps) {
  return (
    <div className={`flex flex-col gap-2 ${className}`.trim()}>
      <StatLine label="Total Profiles" value={totals.totalProfiles ?? 0} />
      <StatLine label="Total Searchable" value={totals.searchable ?? 0} />
      <StatLine
        label="Total Non-Searchable"
        value={totals.nonSearchable ?? 0}
      />
    </div>
  );
}
